/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, "count, plural, one {": NonNullable<unknown>, s: NonNullable<unknown> }} Knp_Lookup_Saved_Changes_ToastInputs */

const en_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saved ${i?.count} change${i?.["count, plural, one {"]} other ${i?.s}} successfully`)
};

const fr_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enregistre ${i?.count} modification${i?.["count, plural, one {"]} other ${i?.s}} avec succes`)
};

const de_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Änderung${i?.["count, plural, one {"]} other ${i?.s}} erfolgreich gespeichert`)
};

const it_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salvata ${i?.count} modifica${i?.["count, plural, one {"]} other ${i?.s}} correttamente`)
};

const ru_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сохранено успешно изменение ${i?.count} на ${i?.["count, plural, one {"]} other ${i?.s}}`)
};

const es_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cambio${i?.["count, plural, one {"]} other ${i?.s}} guardado correctamente`)
};

const zh_cn2_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已成功保存 ${i?.count} 更改 ${i?.["count, plural, one {"]} other ${i?.s}}`)
};

const ja_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} の変更 ${i?.["count, plural, one {"]} other ${i?.s}} を正常に保存しました`)
};

const hi_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} परिवर्तन ${i?.["count, plural, one {"]} other ${i?.s}} सफलतापूर्वक सहेजा गया`)
};

const pt_pt2_knp_lookup_saved_changes_toast = /** @type {(inputs: Knp_Lookup_Saved_Changes_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alteração ${i?.count} ${i?.["count, plural, one {"]} other ${i?.s}} salva com sucesso`)
};

/**
* | output |
* | --- |
* | "Saved {count} change{count, plural, one {} other {s}} successfully" |
*
* @param {Knp_Lookup_Saved_Changes_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_saved_changes_toast = /** @type {((inputs: Knp_Lookup_Saved_Changes_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Saved_Changes_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_saved_changes_toast(inputs)
	if (locale === "de") return de_knp_lookup_saved_changes_toast(inputs)
	if (locale === "it") return it_knp_lookup_saved_changes_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_saved_changes_toast(inputs)
	if (locale === "es") return es_knp_lookup_saved_changes_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_saved_changes_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_saved_changes_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_saved_changes_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_saved_changes_toast(inputs)
	return en_knp_lookup_saved_changes_toast(inputs)
});